import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUnmute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M259.666 46.288c-16.146 0-143.103 123.087-143.103 123.087H25.745c-7.51 0-13.556 6.843-13.556 15.342v143.327c0 8.499 6.046 15.341 13.556 15.341h95.516s123.092 117.637 138.405 117.637c18.422 0 33.25-18.854 33.25-42.277V88.568c0-23.423-14.828-42.28-33.25-42.28z",
			fill: "currentColor",
			paintOrder: "stroke fill markers"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M401.129 82.06a16.193 16.193 0 00-12.543 5.784 16.193 16.193 0 001.996 22.814 192.39 192.39 0 0168.736 147.404 192.39 192.39 0 01-68.736 147.405 16.193 16.193 0 00-1.996 22.812 16.193 16.193 0 0022.812 1.996 224.84 224.84 0 0080.305-172.212A224.84 224.84 0 00411.398 85.85a16.193 16.193 0 00-10.27-3.79z",
			fontWeight: 400,
			fontFamily: "sans-serif",
			overflow: "visible",
			fill: "currentColor",
			paintOrder: "stroke fill markers"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M364.867 135.305a16.193 16.193 0 00-12.205 5.783 16.193 16.193 0 001.996 22.812 122.888 122.888 0 0143.908 94.162c0 36.345-16.066 70.8-43.908 94.163a16.193 16.193 0 00-1.996 22.812 16.193 16.193 0 0022.813 1.996 155.338 155.338 0 0055.476-118.97c0-45.897-20.318-89.47-55.476-118.971a16.193 16.193 0 00-10.608-3.787z",
			fontWeight: 400,
			fontFamily: "sans-serif",
			overflow: "visible",
			fill: "currentColor",
			paintOrder: "stroke fill markers"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M330.553 188.547a16.193 16.193 0 00-12.543 5.783 16.193 16.193 0 001.996 22.815 53.383 53.383 0 0119.082 40.917c0 15.8-6.979 30.763-19.082 40.918a16.193 16.193 0 00-1.996 22.813 16.193 16.193 0 0022.812 1.996 85.833 85.833 0 0030.65-65.726 85.833 85.833 0 00-30.65-65.727 16.193 16.193 0 00-10.27-3.79z",
			fontWeight: 400,
			fontFamily: "sans-serif",
			overflow: "visible",
			fill: "currentColor",
			paintOrder: "stroke fill markers"
		})
	]
});
export { SvgIconUnmute as ReactComponent };
